module.exports = __webpack_public_path__ + "media/images/icons/skype-42407a23e167f33e73a94e874b0045ff.svg";